<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers">
          <div>
            <el-button type="primary" @click="toQuery">{{ $t('common.btn.refresh') }}</el-button>
            <el-button
              v-permission="['write_SMSeaPort']"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              v-permission="['write_SMSeaPort']"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button
              v-permission="['write_SMSeaPort']"
              type="danger"
              @click="remove"
            >{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="100102"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="total>0"
          config-module="1001021"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="editDialog.visible" class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.seaport.tabEdiPort.shipCompany')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Company"
              :cache="false"
              filterable
              :callback-params="{key:'condition1'}"
              callback-method-type="value"
              :default-value="editDialog.form.condition1"
              :static-options="seaCmpList"
              :custom-selected-label="customSelectedLabel"
              style="width:310px;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.seaport.tabEdiPort.originPortCode')">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Seaport"
              :cache="false"
              filterable
              :callback-params="{key:'sourceValue'}"
              callback-method-type="value"
              :default-value="editDialog.form.sourceValue"
              :static-options="seaPortList"
              style="width:310px;"
              @parentCallBack="selectCargoItem"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.seaport.tabEdiPort.currentPortCode')">
            <el-input v-model="editDialog.form.targetValue" maxlength="5" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import initTemplate from '@/utils/vueInitTemplate'
import { cacheName, cache } from '@/utils/cacheManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCompanyListByType4Cache } from '@/api/company'
import { getSeaPortList, getEdiPortList, saveEdiPort, delEdiPort } from '@/api/seaport'
import { Company } from '@/class/model/mdm/Company'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'EdiPort',
  components: { cargoAdvanceSelect },
  data() {
    return {
      ...initTemplate.data,
      office: {},
      configMap: new Map(),
      selectTypeNames: TYPE_NAMES,
      filter: {
        branchId: 0,
        type: 'SP',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressRowClickSelection: false,
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('baseInfo.seaport.tabEdiPort.shipCompany'),
          field: 'companyName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.seaport.tabEdiPort.originPortCode'),
          field: 'sourceValue',
          width: 200
        }, {
          headerName: this.$t('baseInfo.seaport.tabEdiPort.currentPortCode'),
          field: 'targetValue',
          width: 200
        }
      ],
      rowData: [],
      companyList: [],
      seaCmpList: [],
      seaPortList: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: {},
        form: {
          uuid: '',
          officeId: '',
          type: 'SP',
          subType: '',
          condition1: '',
          companyName: '',
          sourceValue: '',
          targetValue: ''
        }
      },
      activeCompany: null
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    customSelectedLabel() {
      if (this.activeCompany) {
        return this.$i18n.locale === 'zh' ? this.activeCompany.chineseName : this.activeCompany.englishName
      } else {
        return null
      }
    }
  },
  watch: {
    'editDialog.form.condition1': async function(newVal) {
      this.activeCompany = await Company.getCompanyById(newVal)
    }
  },
  created() {
    this.editDialog.initialForm = this.editDialog.form
    /* Promise Begin */
    getCompanyListByType4Cache({ type: 'seaCmp' }).then(res => {
      this.companyList = res.data.list
      this.configCompanyLang(this.companyList)
    }).then(() => {
      this.completeInit()
    }).then(() => {
      this.toQuery()
    })
    /* Promise End */
  },
  methods: {
    ...initTemplate.methods,
    async preloadBasicData() {
      await cache.load(cacheName.OFFICE, cacheName.CONFIG)
      this.office = cache.office
      this.configMap = cache.config
    },
    onShow() {
      this.afterInit(() => {
        this.loading = getLoading()
        getSeaPortList({ pageNum: 1, pageSize: 1000000 }).then(res => {
          this.seaPortList = res.data.list
          this.loading.close()
        })
      })
    },
    configCompanyLang(companyList) {
      if (companyList.length === 0) {
        return
      }
      for (const item of companyList) {
        item.companyName = this.$i18n.locale === 'zh' ? item.chineseName : item.englishName
      }
    },
    toQuery() {
      const self = this
      getEdiPortList(self.filter).then(res => {
        self.bindCompanyName(res.data.list)
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      })
    },
    bindCompanyName(data) {
      if (this.companyList.length === 0 || data.length === 0) {
        return
      }
      if (data[0].companyName) {
        return
      }
      const map = new Map()
      for (const item of this.companyList) {
        map.set(item.cmpIdx, item.companyName)
      }
      for (const item of data) {
        item.companyName = map.get(item.condition1)
      }
    },
    async showEditDialog(isNew) {
      await this.preloadBasicData()
      const officeId = this.office.officeId
      // 是否启用合作伙伴管理模式
      const partnerManagementMode = Number(this.configMap.get('PartnerManagementMode'))
      if (partnerManagementMode === 1) {
        this.seaCmpList = this.companyList.filter(p => p.seaCmp && p.branchId > 1 && p.branchId === officeId)
      } else {
        this.seaCmpList = this.companyList.filter(p => p.seaCmp && (p.branchId === 1 || p.branchId === officeId))
      }
      if (isNew) {
        this.editDialog.form = JSON.parse(JSON.stringify(this.editDialog.initialForm))
        this.editDialog.form.officeId = officeId
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = JSON.parse(JSON.stringify(rows[0]))
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    selectCargoItem(item) {
      this.editDialog.form[item.key] = item.value
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.condition1) {
        self.$message.warning(self.$t('baseInfo.seaport.tabEdiPort.shipCompanyCheck'))
        return
      }
      if (!form.sourceValue) {
        self.$message.warning(self.$t('baseInfo.seaport.tabEdiPort.originPortCodeCheck'))
        return
      }
      if (form.targetValue.length < 5) {
        self.$message.warning(self.$t('baseInfo.seaport.tabEdiPort.currentPortCodeCheck'))
        return
      }
      saveEdiPort(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delEdiPort(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    }
  }
}
</script>
